// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"93e0cbf6","551":"321e765e","730":"bfaf64c8","842":"62c3bb77"}[chunkId] + ".chunk.js";
};